import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

export default function TermsPage() {
    return (
        <div data-testid="terms-page">
            <PageHero
                eyebrow="About BENNE"
                title="Terms & Conditions"
                lead="The rules that govern your use of BENNE. By accessing the site or submitting a release, you agree to these terms. Last updated February 2026."
                breadcrumbs={[
                    { label: "Home", to: "/" },
                    { label: "About", to: "/about" },
                    { label: "Terms & Conditions" },
                ]}
            />
            <div className="px-4 md:px-8 lg:px-12 py-16 max-w-3xl font-sofia text-base text-[#1B1B1B]/85 leading-[1.8] space-y-6">
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        1. Use of the site
                    </h2>
                    <p>
                        You may read, share, link to and quote content on BENNE
                        for personal and editorial purposes with attribution.
                        Commercial reuse requires written permission.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        2. Submissions
                    </h2>
                    <p>
                        By submitting a press release, you confirm you have the
                        rights to all text and images included, and grant BENNE
                        a non-exclusive license to publish, edit and distribute
                        the material across our channels.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        3. Paid services
                    </h2>
                    <p>
                        Featured and Concierge tiers are refundable until
                        editorial work begins. Refunds are not available once a
                        piece enters production.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        4. Conduct
                    </h2>
                    <p>
                        Hate speech, harassment, doxxing or material that
                        violates the rights of others will be removed. We
                        reserve the right to ban repeat offenders.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        5. Limitation of liability
                    </h2>
                    <p>
                        BENNE is provided "as is." We make no warranty as to
                        accuracy or fitness for any particular purpose. To the
                        maximum extent permitted by law, we disclaim liability
                        for indirect or consequential damages.
                    </p>
                </section>
                <section>
                    <h2 className="font-poppins font-bold text-xl text-[#E63B26]">
                        6. Contact
                    </h2>
                    <p>
                        Questions? Use our{" "}
                        <Link
                            to="/contact"
                            className="text-[#E63B26] underline hover:text-[#1B1B1B]"
                            data-testid="terms-contact-link"
                        >
                            contact form
                        </Link>
                        .
                    </p>
                </section>
            </div>
        </div>
    );
}
